jQuery(function() {
    //Paginator next and previous link formation when deal cards or image card present on the page
    function setFilter(dropdown_class, container_class_filter) {
        var selected_option = jQuery("." + dropdown_class + " option:selected").val();
        if (jQuery("." + container_class_filter + "").length > 0) {
            jQuery("input[name=filter]").val(selected_option);
        }
    }

    function setPaginatorLink(container_class_link, card_type) {
        if (jQuery("." + container_class_link + "").length > 0) {
            var next_paginator = jQuery(".paginator__next-link");
            var prev_paginator = jQuery(".paginator__previous-link");
            var get_filter = jQuery("input[name=filter]").val();
            var next_page = jQuery("input[name=" + card_type + "_cards_next]").val();
            var prev_page = jQuery("input[name=" + card_type + "_cards_previous]").val();
            var next_url = "?filter=" + get_filter + "&p=" + next_page;
            var prev_url = "?filter=" + get_filter + "&p=" + prev_page;
            next_paginator.attr("href", next_url);
            prev_paginator.attr("href", prev_url);
        }
    }

    function exceedPagesMessage(totalNoPages) {
        var allError = document.querySelectorAll(".search_Error_message")
          , pageInputField = document.querySelector("input.paginator__text[name='p']")
          , alphabets = /^[a-zA-Z]+$/;

        if (parseInt(pageInputField.value) > totalNoPages || parseInt(pageInputField.value) == 0 || pageInputField.value.match(alphabets)) {
            for (var i = 0; i < allError.length; i++) {
                allError[i].parentNode.removeChild(allError[i]);
            }

            pageInputField.style.borderColor = "#f55f52";

            const paginator = document.querySelector(".paginator");
            const errorMessage = document.createElement("p");

            errorMessage.classList.add("account-info-card__alert", "search_Error_message");

            errorMessage.setAttribute("role", "alert");
            errorMessage.setAttribute("aria-live", "polite");
            errorMessage.style.textAlign = "center";

            errorMessage.textContent = `Error: The page number you entered is invalid. Please enter a value between 1 and ${totalNoPages}.`;

            paginator.appendChild(errorMessage);

            pageInputField.focus();

            return false;
        }
        return true;
    }

    //deafult
    jQuery(document).on("submit", "form[data-pjax]", function(e) {
        var totalPage = Number($(".paginator__number-of-pages").text());
        var isformAllowedtoSubmit = exceedPagesMessage(totalPage);
    
        if (!isformAllowedtoSubmit) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            var urlParams = new URLSearchParams(window.location.search);
            var currentPageVal = Number($("input[name=p]").val());
            
            urlParams.set('p', currentPageVal);
            sessionStorage.setItem("reloading", "true");
            window.location.search = urlParams.toString();
        }
        return false;
    });

    jQuery(document).on("pjax:complete", function() {
        var p = new URLSearchParams(window.location.search).get("p");
        if (p) {
            $("#page_number").val(p);
        }

        //deal cards make links for next and prev page
        setFilter("deal-cards__filter", "deal-cards__filter-container");
        setPaginatorLink("deal-cards__filter-container", "deal");

        //image cards make links for next and prev page
        setFilter("image-cards__filter", "image-cards__filter-container");
        setPaginatorLink("image-cards__filter-container", "image");
    });

    //AODA : To set focus for search results page after page change
    function focusOnPageChange() {
        jQuery("#search-header__results-detail").focus();
    }

    //AODA : To set focus for search results page after page change - Check if reloading is set in session storage
    if (jQuery(".search-results__result").length > 0) {
        window.onload = function() {
            var reloading = sessionStorage.getItem("reloading");
            if (reloading) {
                sessionStorage.removeItem("reloading");
                focusOnPageChange();
            }
        }
        ;
    }

    //AODA : To set focus for search results page after page change - Set Loading in session storage once user enter page number
    if (jQuery(".search-results__result").length > 0) {
        jQuery(document).on("submit", ".paginator form", function(e) {
            sessionStorage.setItem("reloading", "true");
        });
    }

    function pageLinkClick($this, linkClass, imageCardClass, dealCardClass, isPrevLinkClicked) {
        if ($this.hasClass(linkClass)) {
            return false;
        }

        //For Image card
        if (jQuery("#image-cards-container").length > 0) {
            jQuery("input[name=p]").val(jQuery(`input[name=${imageCardClass}]`).val());
        }

        //For Deal card
        if (jQuery("#deal-cards-container").length > 0) {
            jQuery("input[name=p]").val(jQuery(`input[name=${dealCardClass}]`).val());
        }

        //For Search result page
        if (jQuery(".search-results__result").length > 0) {
            var urlParams = new URLSearchParams(window.location.search);
            var currentPageVal = Number(isPrevLinkClicked ? urlParams.get('p') : $("input[name=p]").val());
            var nextPage;

            if (isPrevLinkClicked) {
                nextPage = currentPageVal ? currentPageVal - 1 : 1;
            } else {
                nextPage = currentPageVal ? currentPageVal + 1 : 1;
            }

            // If page count is 0 then it's equivalent of loading first page.
            if (nextPage === 0) {
                urlParams.delete('p');
            } else {
                urlParams.set('p', nextPage);
            }

            sessionStorage.setItem("reloading", "true");
            window.location.search = urlParams.toString();
        }
    }

    //Previous page button event handling
    jQuery(document).on("click", ".paginator__previous-link", function(e) {
        if (jQuery(".date-links").length == 0) {
            if (jQuery(".attraction-cards").length == 0) {
                e.preventDefault();
                var $this = jQuery(this);
                pageLinkClick($this, "paginator__previous-link--disabled", "image_cards_previous", "deal_cards_previous", true);

                return false;
            }
        }
    });

    //Next page button event handling
    jQuery(document).on("click", ".paginator__next-link", function(e) {
        if (jQuery(".date-links").length == 0) {
            if (jQuery(".attraction-cards").length == 0) {
                e.preventDefault();
                var $this = jQuery(this);

                pageLinkClick($this, "paginator__next-link--disabled", "image_cards_next", "deal_cards_next", false);

                return false;
            }
        }
    });

    function PrevLinkDisable(total_number_of_pages) {
        var total_page_numbers = jQuery("input[name=" + total_number_of_pages + "]").val();
        if (total_page_numbers == 1) {
            jQuery(".paginator__previous-link").addClass("paginator__previous-link--disabled");
            jQuery(".paginator__previous-link").attr("aria-hidden", "true");
        }
    }
    // * CNCI-336 - check first before pjax
    if (jQuery(".pjax-container").length) {
        var $pajx_scroll_position = jQuery(".pjax-container").offset().top - 51;
        jQuery(document).on("pjax:complete", function() {
            jQuery(window).scrollTop($pajx_scroll_position);

            //Disable Prev link if the result is just one page
            PrevLinkDisable("image_cards_total_pages");
            PrevLinkDisable("deal_cards_total_pages");
        });
    }
});